import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models'

export class IllnessApiService extends ApiService {
  static async createIllness(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('illnesses', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async updateIllness(illnessId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`illnesses/${illnessId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchIllnessCategories(): Promise<IServiceResponse<object>> {
    return this.axios.get('illness-categories')
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchIllnesses(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('illnesses', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async fetchIllness(illnessId: number): Promise<IServiceResponse<object>> {
    return this.axios.get(`illnesses/${illnessId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async deleteIllness(illnessId: number): Promise<AxiosResponse> {
    return this.axios.delete(`illnesses/${illnessId}`).then(response => response.data)
  }

  static async deletePhase(illnessPhaseId: number): Promise<IServiceResponse<object>> {
    return this.axios.delete(`illness-phases/${illnessPhaseId}`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async startNextPhase(illnessId: number, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`illnesses/${illnessId}/next-phase`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async submitNote(illnessPhaseId: number, data: object): Promise<object> {
    return this.axios.post(`illness-phases/${illnessPhaseId}/note`, data)
      .then(response => response.data)
  }

  static async getPdfReport(illnessId: number): Promise<{ url: string }> {
    return this.axios.get(`illnesses/${illnessId}/pdf`)
      .then((response: AxiosResponse<{ url: string }>) => response.data)
  }
}
